// As we agreed we are creating our FE ideal interfaces. Feel free to extend this with Optional
// parameters that you neeed

export interface ProductLine {
  id: number;
  code: string;
  name?: string;
  disabled?: boolean;
}
